/**
 * C-45 «Ключ шифрования звонка» (изменение v1.14).
 *
 * Четыре эмодзи из общего ключа звонка — как в Telegram. Если у собеседника те же эмодзи в том
 * же порядке, никто между вами (включая сервер) ключи не подменял: разговор слышите только вы
 * двое. Панель живёт внутри экрана звонка, а не отдельным листом: лист оказался бы под ним.
 */
import { SAS_EMOJI } from '@shared/crypto/sas-emoji'
import { Button, Icon } from '@shared/ui'

import styles from './call.module.css'

interface CallKeyPanelProps {
  sas: readonly number[]
  peerName: string
  /** Звонок идёт только через ретранслятор (настройка «Прямое соединение в звонках»). */
  relayOnly: boolean
  onClose: () => void
}

export function CallKeyPanel({ sas, peerName, relayOnly, onClose }: CallKeyPanelProps) {
  const emoji = sas.map((index) => SAS_EMOJI[index]).filter((item) => item !== undefined)
  return (
    <div className={styles['keyPanel']} role="dialog" aria-modal="false" aria-labelledby="call-key-title">
      <div className={styles['keySheet']}>
        <h2 id="call-key-title" className={styles['keyTitle']}>
          <Icon name="lock" size={18} />
          Ключ шифрования звонка
        </h2>
        <div
          className={styles['keyEmoji']}
          aria-label={`Эмодзи ключа: ${emoji.map((item) => item.name).join(', ')}`}
        >
          {emoji.map((item, position) => (
            <span key={position} className={styles['keyItem']}>
              <span className={styles['keyGlyph']} aria-hidden="true">
                {item.emoji}
              </span>
              {item.name}
            </span>
          ))}
        </div>
        <p className={styles['keyText']}>
          Если у <strong>{peerName}</strong> на экране те же четыре эмодзи в том же порядке, звонок защищён
          сквозным шифрованием: разговор слышите только вы двое, а сервер «Движа» передаёт лишь зашифрованные
          данные. Назовите эмодзи вслух — собеседник сверит их со своими.
        </p>
        <p className={styles['keyText']}>
          Ключи создаются заново для каждого звонка и хранятся только в памяти ваших устройств. Звонок нигде
          не записывается.{' '}
          {relayOnly
            ? 'Соединение идёт только через сервер-посредник — собеседник не видит ваш IP-адрес.'
            : 'Прямое соединение разрешено — собеседнику может быть виден ваш IP-адрес.'}
        </p>
        <Button fullWidth onClick={onClose}>
          Понятно
        </Button>
      </div>
    </div>
  )
}
